import axios from '../../axios/axios';
import * as actionTypes from '../constants/actionTypes';

const getPermissionsStart = () => {
  return {
    type: actionTypes.GET_PERMISSIONS_START,
  };
};

const getPermissionsSuccess = (data) => {
  return {
    type: actionTypes.GET_PERMISSIONS_SUCCESS,
    data,
  };
};

const getPermissionsFail = (error) => {
  return {
    type: actionTypes.GET_PERMISSIONS_FAIL,
    error,
  };
};

export const getPermissions = () => {
  return (dispatch) => {
    dispatch(getPermissionsStart());
    const url = `/users/permissions`;
    axios
      .get(url)
      .then((response) => {
        dispatch(getPermissionsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPermissionsFail(err));
      });
  };
};

const hasAccessToInfusionSoftStart = () => {
  return {
    type: actionTypes.HAS_ACCESS_TO_INFUSION_SOFT_START,
  };
};

const hasAccessToInfusionSoftSuccess = (data) => {
  return {
    type: actionTypes.HAS_ACCESS_TO_INFUSION_SOFT_SUCCESS,
    data,
  };
};

const hasAccessToInfusionSoftFail = (error) => {
  return {
    type: actionTypes.HAS_ACCESS_TO_INFUSION_SOFT_FAIL,
    error,
  };
};

export const hasAccessToInfusionSoft = () => {
  return (dispatch) => {
    dispatch(hasAccessToInfusionSoftStart());
    const url = `/users/has-access-to-infusion-soft`;
    axios
      .get(url)
      .then((response) => {
        dispatch(hasAccessToInfusionSoftSuccess(response.data));
      })
      .catch((err) => {
        dispatch(hasAccessToInfusionSoftFail(err));
      });
  };
};
